export default class BaseClient {
  constructor(videoCode) {
    this.videoCode = videoCode
  }

  pause() { }

  readyPlay() {}
}
